const setIcons = (item, productId, variantId) => {
  const emptyIcon = item.querySelector('.product-grid__wd-custom-iwish .empty-icon');
  const fullIcon = item.querySelector('.product-grid__wd-custom-iwish .full-icon');
  if (!emptyIcon || !fullIcon) return;

  if (typeof iWish !== 'undefined' && iWish.isInWishlist(variantId)) {
    emptyIcon.classList.add('hide');
    fullIcon.classList.remove('hide');
  } else {
    fullIcon.classList.add('hide');
    emptyIcon.classList.remove('hide');
  }
};

// Product Page UI Improvements - December 2024
document.addEventListener('DOMContentLoaded', function() {
    // Add read more functionality for product descriptions - MOBILE ONLY
    if (window.innerWidth < 769) {
        const descBlocks = document.querySelectorAll('.product-description-block');
        
        descBlocks.forEach(block => {
            const rte = block.querySelector('.rte');
            if (rte && rte.scrollHeight > 80) {
                const readMoreBtn = document.createElement('span');
                readMoreBtn.className = 'read-more-btn';
                readMoreBtn.textContent = 'קרא עוד';
                
                // Check if there's a product label button
                const productLabel = block.querySelector('.more_info__product-label');
                if (productLabel) {
                    // Insert read more before the product label
                    productLabel.parentNode.insertBefore(readMoreBtn, productLabel);
                } else {
                    // Append at the end
                    block.appendChild(readMoreBtn);
                }
                
                readMoreBtn.addEventListener('click', function() {
                    block.classList.toggle('expanded');
                    readMoreBtn.textContent = block.classList.contains('expanded') ? 'קרא פחות' : 'קרא עוד';
                });
            }
        });
    }
    
    // DISABLED: Breadcrumbs now positioned in info column via Liquid template
    // The breadcrumbs element is placed directly in product-grid__content before product-single__meta
    // No JavaScript manipulation needed - positioning handled by CSS
});

const toggleVariant = (productId, variantId) => {
  if (typeof iWish === 'undefined') return;

  if (iWish.isInWishlist(variantId)) {
    iWish.iwishRemove(variantId, productId);
  } else {
    iWish.iwishAdd(variantId, productId, 1);
  }
};

const setWishListButton = (btn, item, productId, variantId) => {
  if (!btn) return;
  setIcons(item, productId, variantId);

  btn.addEventListener("click", () => {
    toggleVariant(productId, variantId);
    setIcons(item, productId, variantId);
    if (window.dataLayer) window.dataLayer.push({'event': 'wishlist'});
  });
};

const setWishlistProductsgrid = () => {
  const prodctsGrid = document.querySelectorAll('.grid-product[data-product-id]');

  prodctsGrid.forEach((item) => {
    const productId = item.getAttribute("data-product-id");
    const variantId = item.getAttribute("data-variant-id");

    if(!item.classList.contains("wishlist-set")) {
      item.classList.add('wishlist-set')
      const wishlistBtn = item.querySelector(`.product-grid__wd-custom-iwish`);

      setWishListButton(wishlistBtn, item, productId, variantId);
    } else {
      setIcons(item, productId, variantId);
    }
  });
};

window.setWishListButton = setWishListButton;
window.setWishlistProductsgrid = setWishlistProductsgrid;

// Banner attribution: inject _banner_source line-item property on PDP add-to-cart
// when the customer arrived via a collection-page banner linking to this product.
// See snippets/wilco-collection-promo-banner.liquid for the click-side write.
(function () {
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || typeof form.matches !== 'function') return;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (form.querySelector('input[name="properties[_banner_source]"]')) return;

    var section = form.closest('[data-product-handle]');
    var productHandle = section && section.getAttribute('data-product-handle');
    if (!productHandle) return;

    var store = {};
    try {
      store = JSON.parse(sessionStorage.getItem('wilcoBannerSources') || '{}');
    } catch (e) { return; }

    // Match the stored banner key to this product. Non-ASCII handles (e.g. Hebrew)
    // can be percent-encoded in storage but decoded in data-product-handle (or vice
    // versa), so compare on a normalized (decoded) form rather than raw equality.
    function normalizeHandle(h) {
      try { return decodeURIComponent(h); } catch (e) { return h; }
    }
    var wanted = normalizeHandle(productHandle);
    var bannerSource = null;
    for (var key in store) {
      if (Object.prototype.hasOwnProperty.call(store, key) && normalizeHandle(key) === wanted) {
        bannerSource = store[key];
        break;
      }
    }
    if (!bannerSource) return;

    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[_banner_source]';
    input.value = bannerSource;
    form.appendChild(input);
  }, true);
})();

// Wait for iWish v3 app to be ready before initializing icons
(function initWishlistWhenReady() {
  if (typeof iWish !== 'undefined') {
    setWishlistProductsgrid();
  } else {
    setTimeout(initWishlistWhenReady, 200);
  }
})();